import BaseSetup from '@/components/BaseSetup';
import useColorService from '@/services/ColorService';
import { Reactive } from '@/utils/decorators';

export type SharedSelectColorEmits = {
	(e: 'input' | 'update:modelValue', val: IColorModel): void
	(e: 'click'): void
};

export type SharedSelectColorProps = {
	disabled?: boolean
	modelValue?: IColorModel
};

export default class SharedSelectColorSetup extends BaseSetup {

	static readonly defaultProps = {
		modelValue: () => ({
			id: 1,
			name: 'brand',
			value: '#2bb9a6',
		}),
	};

	@Reactive private readonly state = {
		state: {
			visible: true,
			loading: false,
		},
		colorOptions: [] as IColorModel[],
	};

	get colorOptions () { return this.state.colorOptions }

	get color () { return this.props.modelValue }
	set color (val: IColorModel | undefined) {
		if (val) {
			this.emits('input', val);
			this.emits('update:modelValue', val);
		}
	}

	constructor (
		private props: SharedSelectColorProps,
		private emits: SharedSelectColorEmits,
	) {
		super();
	}

	async onBeforeMountAsync () {
		await this.getColorOptionsAsync();
	}

	selectColor (color: IColorModel) {
		this.color = color;
		this.emits('click');
	}

	private async getColorOptionsAsync () {
		this.state.colorOptions = await useColorService().listAsync();
	}

}
